module.exports = __webpack_public_path__ + "img/1-5.df0d546a.svg";